<template>
  <b-modal
    centered
    ref="ThongTinDonVi"
    no-close-on-backdrop
    size="xl"
    hide-footer
    :title="`${data ? 'Sửa' : 'Thêm mới'} thông tin đơn vị / chức vụ`"
  >
    <b-form class="font-size-14">
      <validation-observer ref="obThongTinDonVi">
        <b-row>
          <b-col cols="6">
            <ValidationProvider
              name="Đơn vị"
              rules="required:select"
              v-slot="validationContext"
            >
              <b-form-group
                label="Tên đơn vị"
                label-class="required"
                label-for="donVi"
              >
                <treeselect
                  :class="
                    selectClass(
                      validationContext.invalid && validationContext.validated
                    )
                  "
                  :state="getValidationState(validationContext)"
                  noOptionsText="Không có dữ liệu"
                  noResultsText="Không có kết quả"
                  noChildrenText="Không có kết quả"
                  v-model="form.donVi"
                  :options="danhSachDonViBanDau || []"
                  placeholder="Chọn đơn vị"
                  :normalizer="normalizer"
                >
                  <label
                    :class="labelClassName"
                    slot="option-label"
                    slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                    }"
                  >
                    {{ node.label }}
                    <span
                      :class="countClassName"
                      v-if="shouldShowCount && count > 0"
                      >({{ count }})</span
                    >
                  </label>
                </treeselect>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="2">
            <b-form-group label="Hiển thị cơ cấu tổ chức">
              <b-form-checkbox
                class="text-center cursor-pointer d-flex"
                :checked="form.isShowTreeCCTC"
                switch
                v-model="form.isShowTreeCCTC"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="Lãnh đạo đơn vị">
              <b-form-checkbox
                class="text-center cursor-pointer d-flex"
                :checked="form.bit_LanhDaoDonVi"
                switch
                v-model="form.bit_LanhDaoDonVi"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="Mặc định">
              <b-form-checkbox
                class="text-center cursor-pointer d-flex"
                :checked="form.macDinh"
                switch
                v-model="form.macDinh"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <ValidationProvider
              name="Chức vụ"
              rules="required:select"
              v-slot="validationContext"
            >
              <b-form-group
                label="Chức vụ"
                label-class="required"
                label-for="chucVu"
              >
                <v-select
                  :class="
                    selectClass(
                      validationContext.invalid && validationContext.validated
                    )
                  "
                  :state="getValidationState(validationContext)"
                  :options="danhSachChucVu"
                  :reduce="(item) => item"
                  label="chucVu"
                  v-model="form.chucVu"
                ></v-select>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="6">
            <ValidationProvider
              name="Trạng thái"
              rules="required:select"
              v-slot="validationContext"
            >
              <b-form-group
                label="Trạng thái"
                label-class="required"
                label-for="trangThai"
              >
                <v-select
                  :class="
                    selectClass(
                      validationContext.invalid && validationContext.validated
                    )
                  "
                  :disabled="disabledFields.includes('trang-thai')"
                  :state="getValidationState(validationContext)"
                  :options="danhSachTrangThai"
                  :reduce="(item) => item"
                  label="name"
                  v-model="form.trangThai"
                  :clearable="false"
                ></v-select>
                <b-form-invalid-feedback
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
    <div style="text-align: center" class="float-right">
      <base-button
        button="Xác nhận"
        size="sm"
        icon="plus-circle-fill"
        class="btn search-information-btn mb-3 mr-2"
        variant="primary"
        @click="onSave()"
        >Tạo</base-button
      >
      <base-button
        button="Đóng"
        size="sm"
        class="btn search-information-btn mb-3 mr-2"
        variant="outline-secondary"
        @click="hideModal()"
        >Hủy
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import _cloneDeep from "lodash/cloneDeep";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Treeselect from "@riophae/vue-treeselect";
import { mapGetters } from "vuex";
const defaultForm = {
  donVi: null,
  chucVu: null,
  trangThai: {
    id: true,
    name: "Hoạt động",
  },
  bit_LanhDaoDonVi: false,
  isShowTreeCCTC: false,
  macDinh: false,
};
export default {
  name: "ModalThemThongTinDonVi",
  components: {
    Treeselect,
  },
  props: {
    danhSachDonViBanDau: {
      type: Array,
      default: null,
    },
    normalizer: {
      type: Function,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    disabledFields: {
      type: Array,
      default: () => {
        return [];
      },
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    reload: function () {
      if (this.data) {
        this.form = _cloneDeep(this.data);
        this.form.donVi = this.form.donVi.id;
      } else {
        this.form = _cloneDeep(defaultForm);
      }
    },
  },
  data() {
    return {
      form: _cloneDeep(defaultForm),
      danhSachTrangThai: [
        {
          id: true,
          name: "Hoạt động",
        },
        {
          id: false,
          name: "Không hoạt động",
        },
      ],
      dataList: [],
      dataDonViSelect: [],
      nameDonVi: [],
    };
  },
  computed: {
    ...mapGetters({
      danhSachChucVu: "chucVu/danhSachChucVu",
    }),
  },
  created() {
    this.layDanhSachChucVu();
  },
  methods: {
    showModal(isMacDinh) {
      if (isMacDinh) {
        this.form.macDinh = true;
      }
      this.$refs.ThongTinDonVi.show();
    },
    hideModal() {
      this.form = _cloneDeep(defaultForm);
      this.$refs.ThongTinDonVi.hide();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    selectClass(valid) {
      return {
        "is-invalid select-invalid treeselect-invalid": valid,
      };
    },
    async onSave() {
      let isValid = await this.$refs.obThongTinDonVi.validate();
      if (!isValid) {
        return;
      }
      this.formatTree(this.danhSachDonViBanDau);
      let searchItem = null;
      let labelConvert = ''
      this.danhSachDonViBanDau.forEach((item) => {
        const get = this.searchTree(item, this.form.donVi);
        if (get) {
          this.labelDonVi(this.dataList, get)
          labelConvert = this.formatLabel(this.dataDonViSelect)
          searchItem = get;
        }
      });
      this.form.donVi = searchItem;
      this.form.donVi.labelName = `${labelConvert} ${searchItem.label}`
      if (this.data) {
        this.$emit("onEdit", this.form);
      } else {
        this.$emit("onSave", this.form);
      }
    },
    layDanhSachChucVu() {
      this.$store.dispatch("chucVu/layDanhSachChucVu");
    },
    labelDonVi(arrdata, dataSelect) {
      arrdata.map(item => {
        if (item.id === dataSelect.parentId) {
          this.dataDonViSelect.push({...item})
          this.labelDonVi(arrdata, item)
        }
      })
      return
    },
    formatLabel(data) {
      const newData = data.reverse()
      let dataLabel = ""
      newData.forEach(item => {
        dataLabel += `${item.label}/ `
      })
      return dataLabel
    },
    formatTree(arrData) {
      const data = []
      if (!arrData) {
        // eslint-disable-next-line no-param-reassign
        arrData = []
      }
      arrData.forEach(item => {
        data.push({ ...item, children: [] })
        if (item.children && item.children.length > 0) {
          data.push(...this.formatTree(item.children))
        }
      })
      return this.dataList = data
    },
    searchTree(element, matchingId) {
      if ((element || {}).id == matchingId) {
        return element;
      } else if (element.children != null) {
        let i;
        let result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingId);
        }
        return result;
      }
      return null;
    },
  },
};
</script>
